import { useMemo } from 'react';
import { useApp } from '@context/AppContext';
import { hasRoles } from '@utils/users-util';
import { UserRole } from 'types/enums';

export const useHasPermissions = (roles: UserRole[]) => {
  const { user, userIsFetched } = useApp();
  return useMemo(
    () => userIsFetched && hasRoles(user.roleStrings, roles),
    [roles, user.roleStrings, userIsFetched]
  );
};

export const usePermissions = () => {
  return {
    isAdmin: useHasPermissions([UserRole.Admin, UserRole.SuperAdmin]),
    isSuperAdmin: useHasPermissions([UserRole.SuperAdmin]),
    isEmployee: useHasPermissions([
      UserRole.SuperAdmin,
      UserRole.Admin,
      UserRole.Owner,
      UserRole.Manager,
      UserRole.Accountant,
      UserRole.Employee,
    ]),
    isManager: useHasPermissions([
      UserRole.SuperAdmin,
      UserRole.Admin,
      UserRole.Owner,
      UserRole.Manager,
    ]),
    isOwner: useHasPermissions([
      UserRole.SuperAdmin,
      UserRole.Admin,
      UserRole.Owner,
    ]),
    isAccountant: useHasPermissions([
      UserRole.SuperAdmin,
      UserRole.Admin,
      UserRole.Owner,
      UserRole.Accountant,
    ]),
  };
};
